
import { z } from "zod";

export type SocialGroupType = {
  id: string;
  name: {
    ar: string;
    en: string;
  };
  description: {
    ar: string;
    en: string;
  };
  type: "whatsapp" | "telegram";
  link: string;
  members: number;
  image_url?: string | null;
};

// Form validation schema
export const formSchema = z.object({
  name_ar: z.string().min(3, {
    message: "يجب أن يكون الاسم بالعربية 3 أحرف على الأقل.",
  }),
  name_en: z.string().min(3, {
    message: "يجب أن يكون الاسم بالإنجليزية 3 أحرف على الأقل.",
  }),
  description_ar: z.string().min(10, {
    message: "يجب أن يكون الوصف بالعربية 10 أحرف على الأقل.",
  }),
  description_en: z.string().min(10, {
    message: "يجب أن يكون الوصف بالإنجليزية 10 أحرف على الأقل.",
  }),
  type: z.enum(["whatsapp", "telegram"], {
    required_error: "يرجى اختيار نوع المجموعة.",
  }),
  link: z.string().url({
    message: "يرجى إدخال رابط صحيح.",
  }),
  members: z.coerce.number().min(0, {
    message: "يجب أن يكون عدد الأعضاء 0 أو أكثر.",
  }),
  image_url: z.string().optional().nullable(),
});

// Default social groups data is now stored in the database
